import React from "react"
import { useGeneralSettings } from "hooks/useGeneralSettings"
import { Modal } from "../Modal"
import "./form-modal.module.scss"
import { useFormFields } from "hooks/useFormFields"
import { FormBuilder } from "components/forms/FormBuilder"
import { KontentItemFormElements } from "components/forms/formBuilder-types"

export const FormModal = () => {
  const { handleCloseModal } = useFormFields()
  const { globalForm } = useGeneralSettings()

  const {
    submit_button_text,
    submission_message_heading,
    submission_message_body,
    heading,
    fields,
    disclaimer,
  } = globalForm?.elements as KontentItemFormElements

  return (
    <Modal onClose={handleCloseModal} variant="solid-single-column">
      <h3 className="fr-form-modal__heading">{heading?.value}</h3>
      <div className="fr-form-modal__body">
        {fields && fields.modular_content.length > 0 && (
          <FormBuilder
            ctaText={submit_button_text?.value}
            submissionMessageHeading={submission_message_heading?.value}
            submissionMessageBody={submission_message_body?.value}
            fields={fields}
            formGridStyle="form-grid-2"
            customId="global-form-modal"
            disclaimer={disclaimer}
          />
        )}
      </div>
    </Modal>
  )
}
